module.exports = __webpack_public_path__ + "img/Produtos04.fw.df188e50.png";